<template>
    <div class="mt-2" v-if="airbnbReservationAlterationRequestLodgixStatusMessage || incorrectAlterationIdMessage">
        <b-card style="width: 100%" class="mb-2">
            <b-card-title class="mb-0" style="font-size: 18px !important">
                <font-awesome-icon
                    v-if="isAirbnb"
                    :icon="[
                        incorrectAlterationIdMessage ? 'fas' : 'fab',
                        incorrectAlterationIdMessage ? 'exclamation-triangle' : 'airbnb',
                    ]"
                    color="red"
                    size="xl"
                    style="margin-left: 22px; margin-bottom: 1px; margin-right: 4px"
                />
                {{
                    incorrectAlterationIdMessage
                        ? incorrectAlterationIdMessage
                        : airbnbReservationAlterationRequestLodgixStatusMessage[0]
                }}
            </b-card-title>
            <b-card-body v-if="!incorrectAlterationIdMessage" class="pb-0">
                <h5>
                    {{ airbnbReservationAlterationRequestLodgixStatusMessage[1] }}
                </h5>
                <h5>
                    {{ airbnbReservationAlterationRequestLodgixStatusMessage[2] }}
                </h5>
            </b-card-body>
        </b-card>
    </div>
    <div v-else>
        <busy-modal
            v-if="airbnbReservationAlterationLoading"
            :show="airbnbReservationAlterationLoading"
            :overlay="false"
        ></busy-modal>
        <div v-else>
            <b-row>
                <b-col md="12" class="summary-container">
                    <b-card
                        style="width: 100%"
                        :class="[
                            `mb-2 ${
                                isAirbnb && airbnbReservationAlterationRequest ? 'bg-info' : 'bg-primary'
                            } summary-card`,
                        ]"
                    >
                        <b-card-title
                            :class="[isAirbnb && airbnbReservationAlterationRequest ? 'mb-0' : '']"
                            :style="isAirbnb && airbnbReservationAlterationRequest ? 'font-size: 16px !important;' : ''"
                        >
                            <font-awesome-icon
                                v-if="isAirbnb"
                                :icon="['fab', 'airbnb']"
                                size="xl"
                                :style="{
                                    marginLeft: airbnbReservationAlterationRequest ? '3px' : '10px',
                                    marginBottom: '1px',
                                    marginRight: '4px',
                                }"
                            />
                            {{ summaryTitle }}
                        </b-card-title>
                        <b-table
                            v-if="!airbnbReservationAlterationRequest"
                            :items="summary[0]"
                            :fields="fields[0]"
                            :borderless="false"
                            class="summary-table summary-table-1"
                            thead-tr-class="summary-table-thead-tr"
                            tbody-tr-class="summary-table-tbody-tr"
                        >
                            <template #head(start_date)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(start_date)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body">{{ data.value }}</span>
                                    <span class="summary-body" v-if="!data.value">N/A</span>
                                </span>
                            </template>

                            <template #head(end_date)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(end_date)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body">{{ data.value }}</span>
                                    <span class="summary-body" v-if="!data.value">N/A</span>
                                </span>
                            </template>

                            <template #head(length)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(length)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body" v-if="data.value > 0"
                                        >{{ data.value }} Night<span v-if="data.value > 1">s</span></span
                                    >
                                    <span class="summary-body" v-if="!data.value">N/A</span>
                                </span>
                            </template>
                        </b-table>
                        <b-table
                            v-if="!airbnbReservationAlterationRequest"
                            :items="summary[1]"
                            :fields="fields[1]"
                            :borderless="false"
                            class="summary-table summary-table-2"
                            thead-tr-class="summary-table-thead-tr"
                            tbody-tr-class="summary-table-tbody-tr"
                        >
                            <template #head(adults)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(adults)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body">{{ data.value }}</span>
                                </span>
                            </template>

                            <template #head(children)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(children)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body">{{ data.value }}</span>
                                </span>
                            </template>

                            <template #head(pets)="data">
                                <span class="summary-cell">
                                    <span class="summary-header">{{ data.label.toUpperCase() }}</span>
                                </span>
                            </template>
                            <template #cell(pets)="data" class="summary-cell">
                                <span class="summary-cell">
                                    <span class="summary-body">{{ data.value }}</span>
                                </span>
                            </template>
                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
            <br />
            <b-row v-if="hasPublishedOwnerStatement">
                <b-col md="12">
                    <b-alert variant="warning" show>
                        Warning! This invoice has already been reconciled to a published owner statement. Any changes
                        will not be reflected on current owner statements.
                    </b-alert>
                </b-col>
            </b-row>
            <validation-observer
                v-if="values"
                ref="form"
                v-slot="{ handleSubmit, meta }"
                as=""
                :initial-values="values"
                validate-on-mount
            >
                <b-card>
                    <div v-if="airbnbReservationAlterationRequest">
                        <h4>
                            <font-awesome-icon
                                :icon="['fab', 'airbnb']"
                                color="red"
                                size="xl"
                                style="margin-bottom: 1px; margin-right: 4px"
                            />
                            Airbnb {{ airbnbReservationAlterationPending ? 'Requested' : 'Reservation' }} Changes
                        </h4>
                        <hr class="divider" />
                        <div>
                            <div v-if="propertyChanged" class="h5 mt-4"><b>New Property</b></div>
                            <div v-else class="h5">Property</div>
                            <div :class="['h6', propertyChanged ? 'font-weight-bold' : '']">
                                <span>{{ airbnbReservationAlterationRequest.property_name }}</span>
                            </div>
                            <div v-if="propertyChanged" class="text-secondary h6">
                                <s
                                    ><span
                                        >Original: {{ airbnbReservationAlterationRequest.property_name_original }}</span
                                    ></s
                                >
                            </div>
                            <div v-if="datesChanged" class="h5 mt-4"><b>New Dates</b></div>
                            <div v-else class="h5 mt-4">Dates</div>
                            <div :class="['h6', datesChanged ? 'font-weight-bold' : '']">
                                <span>{{ airbnbReservationAlterationRequestFromDateDisplay }}</span>
                                <span> - </span>
                                <span>{{ airbnbReservationAlterationRequestToDateDisplay }}</span>
                            </div>
                            <div v-if="datesChanged" class="text-secondary h6">
                                <s>
                                    <span
                                        >Original: {{ airbnbReservationAlterationRequestFromDateOriginalDisplay }}</span
                                    >
                                    <span> - </span>
                                    <span>{{ airbnbReservationAlterationRequestToDateOriginalDisplay }}</span>
                                </s>
                            </div>
                            <div v-if="guestsChanged" class="h5 mt-4"><b>New Guests</b></div>
                            <div v-else class="h5 mt-4">Guests</div>
                            <div :class="['h6', guestsChanged ? 'font-weight-bold' : '']">
                                <span>{{ airbnbReservationAlterationRequestGuestsDisplay }}</span>
                            </div>
                            <div v-if="guestsChanged" class="text-secondary h6">
                                <s
                                    ><span
                                        >Original: {{ airbnbReservationAlterationRequestGuestsOriginalDisplay }}</span
                                    ></s
                                >
                            </div>
                            <hr class="divider" />
                            <b-row class="flex-column flex-md-row w-100 m-0">
                                <b-col class="p-0 col-12 col-md-4">
                                    <div v-if="hostPayoutChanged" class="h5 mt-4"><b>New Host Payout</b></div>
                                    <div v-else class="h5">Host Payout</div>
                                    <div :class="['h6', hostPayoutChanged ? 'font-weight-bold' : '']">
                                        <span>{{ airbnbReservationAlterationRequestPayoutDisplay }}</span>
                                    </div>
                                    <div v-if="hostPayoutChanged" class="text-secondary h6">
                                        <s
                                            ><span
                                                >Original:
                                                {{ airbnbReservationAlterationRequestPayoutOriginalDisplay }}</span
                                            ></s
                                        >
                                    </div>
                                </b-col>
                                <b-col class="p-0 mt-4 mt-md-0 col-12 col-md-8">
                                    <div class="h5">Guest total, including fees and taxes</div>
                                    <div class="h6">
                                        <span>{{ airbnbReservationAlterationRequestTotalDisplay }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <busy-modal :show="loading" :overlay="true"></busy-modal>
                    <b-form v-if="!airbnbReservationAlterationRequest" @submit.prevent="">
                        <b-row>
                            <b-col v-if="!isAirbnb" md="4" class="guest-container">
                                <validation-provider name="full_name" v-slot="{ errors }" rules="required" >
                                    <form-input
                                        floating-label="Guest"
                                        v-model="values.full_name"
                                        :rightButton="{
                                            title: '',
                                            icon: ['fas', 'magnifying-glass'],
                                            variant: 'primary',
                                        }"
                                        @click="$bvModal.show('select-guest-modal')"
                                        @handle-right-button-click="$bvModal.show('select-guest-modal')"
                                        :error="errors[0]"
                                        id="guest-input"
                                        class="mt-2"
                                        readonly
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                            <b-col v-if="isAirbnb" md="4">
                                <validation-provider
                                    name="airbnb_feedshare_id"
                                    v-slot="{ errors }"
                                    rules="required"
                                    
                                >
                                    <form-select
                                        v-model="values.airbnb_feedshare_id"
                                        class="mt-2"
                                        :options="airbnbPropertyOptions"
                                        @change="fetchAirbnbReservationAlterationQuoteDebounce"
                                        floating-label="Property"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                            <b-col md="4">
                                <validation-provider name="from_date" v-slot="{ errors }" rules="required" >
                                    <form-datepicker
                                        v-model="values.from_date"
                                        floating-label="Start Date"
                                        :floating-label-asterisk="true"
                                        class="mt-2"
                                        :hide-header="true"
                                        :display-format="userUnicodeDateFormat"
                                        :error="errors[0]"
                                        @input="handleFromDateChange"
                                        :no-gutters="true"
                                    ></form-datepicker>
                                </validation-provider>
                            </b-col>
                            <b-col md="4">
                                <validation-provider name="to_date" v-slot="{ errors }" rules="required" >
                                    <form-datepicker
                                        v-model="values.to_date"
                                        floating-label="End Date"
                                        :floating-label-asterisk="true"
                                        class="mt-2"
                                        :hide-header="true"
                                        :display-format="userUnicodeDateFormat"
                                        :error="errors[0]"
                                        @input="handleToDateChange"
                                        ref="toDatePicker"
                                        :no-gutters="true"
                                    ></form-datepicker>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <br />
                        <properties-table v-if="!isAirbnb" :value="values.properties"></properties-table>
                        <b-row v-if="isAirbnb">
                            <b-col md="4" class="guest-container">
                                <validation-provider
                                    name="adults"
                                    v-slot="{ errors }"
                                    rules="required|validPositiveOrZeroInteger"
                                    
                                >
                                    <form-input
                                        floating-label="Adults"
                                        v-model="values.adults"
                                        :rightButton="{ title: '', icon: ['fas', 'user'], variant: 'primary' }"
                                        @change="fetchAirbnbReservationAlterationQuoteDebounce"
                                        :error="errors[0]"
                                        id="adults-input"
                                        class="mt-2"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                            <b-col md="4">
                                <validation-provider
                                    name="children"
                                    v-slot="{ errors }"
                                    rules="required|validPositiveOrZeroInteger"
                                    
                                >
                                    <form-input
                                        floating-label="Children"
                                        v-model="values.children"
                                        :rightButton="{ title: '', icon: ['fas', 'user'], variant: 'primary' }"
                                        @change="fetchAirbnbReservationAlterationQuoteDebounce"
                                        :error="errors[0]"
                                        id="children-input"
                                        class="mt-2"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                            <b-col md="4">
                                <validation-provider
                                    name="pets"
                                    v-slot="{ errors }"
                                    rules="required|validPositiveOrZeroInteger"
                                    
                                >
                                    <form-input
                                        floating-label="Pets"
                                        v-model="values.pets"
                                        :rightButton="{ title: '', icon: ['fas', 'dog'], variant: 'primary' }"
                                        @change="fetchAirbnbReservationAlterationQuoteDebounce"
                                        :error="errors[0]"
                                        id="children-input"
                                        class="mt-2"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <br />
                        <b-row v-if="isAirbnb">
                            <b-col md="4">
                                <validation-provider
                                    name="total_price"
                                    v-slot="{ errors }"
                                    rules="validPositiveInteger"
                                    
                                >
                                    <form-input
                                        v-model="values.total_price"
                                        floating-label="Accommodation cost (optional)"
                                        :empty-value="null"
                                        :error="errors[0]"
                                        :description="
                                            !!values.total_price ? `${pricePerNightDisplay} x ${nightsDisplay}` : ''
                                        "
                                        @change="fetchAirbnbReservationAlterationQuoteDebounce"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <div v-if="airbnbReservationAlterationPriceQuote">
                            <hr class="divider" />
                            <b-row class="flex-column flex-md-row w-100 m-0">
                                <b-col class="p-0 col-12 col-md-4">
                                    <div class="h5">Host payout</div>
                                    <div class="h6">
                                        <span>{{ airbnbReservationAlterationPriceQuotePayoutDisplay }}</span>
                                    </div>
                                    <div
                                        v-if="
                                            airbnbReservationAlterationPriceQuotePayoutOriginalDisplay &&
                                            airbnbReservationAlterationPriceQuotePayoutDisplay !==
                                                airbnbReservationAlterationPriceQuotePayoutOriginalDisplay
                                        "
                                        class="text-secondary"
                                    >
                                        <s
                                            ><span>{{
                                                airbnbReservationAlterationPriceQuotePayoutOriginalDisplay
                                            }}</span></s
                                        >
                                    </div>
                                </b-col>
                                <b-col class="p-0 mt-md-0 col-12 col-md-8">
                                    <div class="h5">Guest total, including fees and taxes</div>
                                    <div class="h6">
                                        <span>{{ airbnbReservationAlterationPriceQuoteTotalDisplay }}</span>
                                    </div>
                                </b-col>
                            </b-row>
                            <hr class="divider" />
                        </div>
                        <br v-if="!isAirbnb" />
                        <b-row v-if="isCreate">
                            <b-col lg="3" md="6" v-if="canModifyInvoiceCreatedDate">
                                <validation-provider name="entered_date" v-slot="{ errors }" rules="required" >
                                    <form-datepicker
                                        v-model="values.entered_date"
                                        floating-label="Date Entered"
                                        class="mt-2"
                                        :hide-header="true"
                                        :display-format="userUnicodeDateFormat"
                                        :error="errors[0]"
                                        :no-gutters="true"
                                    ></form-datepicker>
                                </validation-provider>
                            </b-col>
                            <b-col :lg="nColsReservationTypeLG" :md="nColsReservationTypeMD">
                                <validation-provider name="stay_type" v-slot="{ errors }" rules="required" >
                                    <form-select
                                        v-model="values.stay_type"
                                        class="mt-2"
                                        :options="stayTypeOptions"
                                        floating-label="Reservation Type"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                            <b-col :lg="nColsTaxExemptionLG" :md="nColsTaxExemptionMD">
                                <validation-provider
                                    name="tax_exemption"
                                    v-slot="{ errors }"
                                    
                                >
                                    <form-select
                                        v-model="values.tax_exemption"
                                        class="mt-2"
                                        :options="taxExemptionOptions"
                                        floating-label="Tax Exemption"
                                        :floating-label-asterisk="true"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                            <b-col lg="3" md="6">
                                <validation-provider
                                    name="tax_exemption_code"
                                    v-slot="{ errors }"
                                    v-if="values.tax_exemption"
                                >
                                    <form-input
                                        floating-label="Tax Exemption Code"
                                        class="mt-2"
                                        v-model="values.tax_exemption_code"
                                        :disabled="!values.tax_exemption"
                                        :error="errors[0]"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row cols="12" v-if="!isCreate && !isAirbnb">
                            <b-col lg="6" md="4">
                                <validation-provider name="stay_type" v-slot="{ errors }" rules="required" >
                                    <form-select
                                        v-model="values.stay_type"
                                        class="mt-2"
                                        :options="stayTypeOptions"
                                        floating-label="Reservation Type"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                            <b-col :lg="nColsTaxExemptionLG" :md="nColsTaxExemptionMD">
                                <validation-provider
                                    name="tax_exemption"
                                    v-slot="{ errors }"                                    
                                >
                                    <form-select
                                        v-model="values.tax_exemption"
                                        class="mt-2"
                                        :options="taxExemptionOptions"
                                        floating-label="Tax Exemption"
                                        :floating-label-asterisk="true"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                            <b-col lg="3" md="4">
                                <validation-provider
                                    name="tax_exemption_code"
                                    v-slot="{ errors }"
                                    
                                    v-if="values.tax_exemption"
                                >
                                    <form-input
                                        floating-label="Tax Exemption Code"
                                        class="mt-2"
                                        v-model="values.tax_exemption_code"
                                        :disabled="!values.tax_exemption"
                                        :error="errors[0]"
                                    ></form-input>
                                </validation-provider>
                            </b-col>
                            <b-col lg="12" md="12" v-if="userDoNotDegradeInvoiceStatus">
                                <validation-provider
                                    name="ignore_do_not_degrade"
                                    v-slot="{ errors }"                                    
                                >
                                    <form-select
                                        v-model="values.ignore_do_not_degrade"
                                        class="mt-2"
                                        :options="ignoreDoNotDegradeInvoiceStatusOptions"
                                        floating-label='Ignore "Do not degrade invoice status"'
                                        :floating-label-asterisk="true"
                                        :error="errors[0]"
                                    ></form-select>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row v-if="values.is_quote && !values.inquiry_pk">
                            <b-col lg="12" md="12">
                                <div class="d-flex">
                                    <div class="flex-grow-1">
                                        <validation-provider
                                            name="inquiry_source_id"
                                            v-slot="{ errors, handleChange }"
                                            rules="required"
                                        >
                                            <form-select
                                                v-model="values.inquiry_source_id"
                                                class="mt-2"
                                                :options="inquirySourceData.options"
                                                floating-label="Inquiry Source"
                                                :error="errors[0]"
                                                :disabled="disallowSourceEditing"
                                                @input="handleChange"
                                            ></form-select>
                       
                                        </validation-provider>
                                    </div>
                        
                                    <b-button
                                        class="ml-2 mt-2 align-self-start inquiry-source-setup-button"
                                        title="Inquiry Source Setup"
                                        v-b-modal="inquirySourceSetupModalId"
                                        variant="primary"
                                        size="lg"
                                        v-if="canManageInquiries && !disallowSourceEditing"
                                    >
                                        <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>


                        <b-row>
                            <b-col lg="12" md="12">
                                <div>
                                    <font-awesome-icon
                                        color="#0D47A1"
                                        :icon="['fas', 'circle-info']"
                                        :style="{ 'vertical-align': 'top', top: '4px', position: 'relative' }"
                                    />
                                    Changes to these attributes may lead to COMPLETE invoice regeneration.
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
                <responsive-button
                    v-if="
                        airbnbReservationAlterationRequest &&
                        airbnbReservationAlterationRequest.initiated_for_guest &&
                        airbnbReservationAlterationPending
                    "
                    variant="outline-danger"
                    class="mt-4 mb-4 save-button"
                    size="lg"
                    :disabled="!meta.valid || loading"
                    :icon="['fab', 'airbnb']"
                    :responsiveness="false"
                    @click="handleCancelClick"
                >
                    Cancel request
                </responsive-button>
                <div class="mt-4" v-else-if="airbnbReservationAlterationRequest && airbnbReservationAlterationPending">
                    <responsive-button
                        variant="danger"
                        size="lg"
                        :disabled="!meta.valid || loading"
                        :icon="['fab', 'airbnb']"
                        :responsiveness="false"
                        @click="handleAcceptClick"
                    >
                        Accept request
                    </responsive-button>
                    <responsive-button
                        variant="outline-danger"
                        size="lg"
                        :disabled="!meta.valid || loading"
                        :responsiveness="false"
                        @click="handleDeclineClick"
                    >
                        Decline
                    </responsive-button>
                </div>
                <responsive-button
                    v-else-if="isAirbnb && !airbnbReservationAlterationRequest"
                    variant="danger"
                    class="mt-4 mb-4 save-button"
                    size="lg"
                    :disabled="!meta.valid || loading || !airbnbReservationAlterationPriceQuote"
                    :icon="['fab', 'airbnb']"
                    :responsiveness="false"
                    @click="handleSubmit(_, handleSendRequestClick)"
                >
                    Send request
                </responsive-button>
                <b-button
                    class="mt-4 mb-4 save-button"
                    size="lg"
                    @click="handleSubmit(_, save)"
                    variant="primary"
                    :disabled="loading || !meta.valid"
                    v-if="!canSendQuote && (!isAirbnb || isImpersonated)"
                >
                    {{ getSaveButtonText() }}&nbsp;&nbsp;<font-awesome-icon
                        color="#fff"
                        :icon="['fas', 'floppy-disk']"
                        :style="{ position: 'relative', top: '1px' }"
                    />
                </b-button>
                <b-button
                    v-else-if="canSendQuote && !isAirbnb"
                    class="mt-4 mb-4 save-button"
                    size="lg"
                    @click="handleSubmit(_, send)"
                    variant="primary"
                    :disabled="loading || !meta.valid"
                >
                    Create Quote&nbsp;&nbsp;<font-awesome-icon
                        color="#fff"
                        :icon="['fas', 'envelope']"
                        :style="{ position: 'relative', top: '1px' }"
                    />
                </b-button>
            </validation-observer>
        </div>
        <select-guest-modal
            @set-reservation-guest="setReservationGuest"
            :initial-values="{
                user_id: values.user_id,
                email: values.email,
                first_name: values.first_name,
                last_name: values.last_name,
            }"
        ></select-guest-modal>
        <modal
            id="ignoreRulesModal"
            header-bg-variant="warning"
            header-text-variant="light"
            ok-variant="primary"
            title="Warning - Rules"
            ok-title="Proceed Anyway"
            @ok="saveIgnore()"
            :static="true"
        >
            <div>{{ ignoreRulesModalValues.message }}:</div>
            <br />
            <div v-for="p in ignoreRulesModalValues.errors">
                <b>{{ p.name }}</b>
                <ul>
                    <li v-for="item in p.errors">{{ item }}</li>
                </ul>
            </div>
            <br />
            <div>Please press "Proceed Anyway" if this is correct.</div>
        </modal>
        <modal
            id="conflictsModal"
            ok-only
            header-bg-variant="danger"
            header-text-variant="light"
            title="Error - Conflict"
            size="conflicts"
            :static="true"
        >
            <div>{{ conflictsModalValues.message }}:</div>
            <br />
            <b-row v-for="item in conflictsModalValues.errors" v-bind:key="item.meta_reservation_id">
                <b-col>
                    <a
                        target="_blank"
                        @click.prevent="item.is_block"
                        :class="{ 'link-disabled': item.is_block }"
                        :href="`/app/reservation/edit/details/${item.meta_reservation_id}`"
                    >
                        {{ item.guest_name }} - {{ item.property_name }} ({{ item.from_date }} - {{ item.to_date }})
                    </a>
                </b-col>
            </b-row>
        </modal>
        <modal
            :id="airbnbReservationAlterationRequestCancelModalId"
            title="Cancel"
            ok-title="Proceed"
            cancel-title="Close"
            @ok="cancelRequest"
        >
            Are you sure you want to cancel your Airbnb reservation alteration request?
        </modal>
        <modal
            :id="airbnbReservationAlterationRequestSendModalId"
            title="Send request"
            ok-title="Proceed"
            cancel-title="Close"
            @ok="sendRequest"
        >
            Are you sure you want to send Airbnb reservation alteration request?
        </modal>
        <modal
            :id="airbnbReservationAlterationRequestAcceptModalId"
            title="Accept request"
            ok-title="Proceed"
            cancel-title="Close"
            @ok="accept"
        >
            Are you sure you want to accept reservation alteration request?
        </modal>
        <modal
            :id="airbnbReservationAlterationRequestDeclineModalId"
            title="Decline"
            ok-title="Proceed"
            cancel-title="Close"
            @ok="decline"
        >
            Are you sure you want to decline this Airbnb reservation alteration request?
        </modal>
        <inquiry-source-setup-modal
            v-if="values.is_quote && !values.inquiry_pk"
            @refreshSources="handleRefreshInquirySources"
            :modal-id="inquirySourceSetupModalId"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import debounce from 'lodash/debounce';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import differenceInDays from 'date-fns/differenceInDays';
    import dateFnsIsValid from 'date-fns/isValid';
    import addDays from 'date-fns/addDays';
    import subDays from 'date-fns/subDays';
    import isEmpty from 'lodash/isEmpty';
    import isNil from 'lodash/isNil';
    import { formatResponseError } from '../../../utils/api';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import FormDatepicker from '../../generic/form-datepicker/form-datepicker.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormSquareSwitch from '../../generic/form-square-switch/form-square-switch.vue';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import Modal from '../../generic/modal/modal.vue';
    import SelectGuestModal from '../details/reservation-details-select-guest-modal.vue';
    import PropertiesTable from './reservation-details-properties-table.vue';
    import InquirySourceSetupModal from './reservation-details-inquiry-source-setup-modal.vue';
    import { toAmountDisplay } from '../../../utils/numbers';
    import {
        RESERVATION_DETAILS_INQUIRY_SOURCE_DATA_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_ACCEPT_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_CANCEL_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_DECLINE_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_FETCH_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_QUOTE_ENDPOINT,
        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_SEND_ENDPOINT,
        PARTNER_AIRBNB_FEED_SHARE_AIRBNB_PROPERTIES_ENDPOINT,
    } from '../../../endpoints';
    import {
        BOOKING_METHOD_AIRBNB,
        ALTERATION_REQUEST_SENT_FOR_ACCEPTANCE,
        ALTERATION_REQUEST_SENT_FOR_DECLINE,
    } from '../../../constants';

    export default {
        name: 'ReservationDetailsForm',
        components: {
            BusyModal,
            FormCheckbox,
            FormDatepicker,
            FormInput,
            FormSquareSwitch,
            ResponsiveButton,
            FormTextarea,
            FormSelect,
            Modal,
            PropertiesTable,
            SelectGuestModal,
            InquirySourceSetupModal,
        },
        props: {
            alterationId: {
                type: String,
                default: '',
            },
            initialValues: {
                type: Object,
                default: () => ({}),
            },
            isCreate: {
                type: Boolean,
                default: false,
            },
            hasPublishedOwnerStatement: {
                type: Boolean,
                default: false,
            },
        },
        provide() {
            return {
                getAvailablePropertiesRequestData: this.getAvailablePropertiesRequestData,
            };
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.onResize);
        },
        mounted() {
            this.fetchInquirySourceData();
            Promise.all([this.fetchAirbnbReservationAlterationRequest(), this.fetchAirbnbProperties()]);
        },
        computed: {
            ...mapGetters('header', [
                'userToday',
                'userCurrencySymbol',
                'userUnicodeDateFormat',
                'userPermissions',
                'userDoNotDegradeInvoiceStatus',
                'isImpersonated',
            ]),
            canSendQuote() {
                return this.values.is_quote && !this.initialValues.id;
            },
            summary() {
                return [
                    [
                        {
                            start_date: this.formatDateWithWeekday(this.values.from_date),
                            end_date: this.formatDateWithWeekday(this.values.to_date),
                            length: this.getReservationLength(),
                        },
                    ],
                    [
                        {
                            adults: this.getReservationCount('adults'),
                            children: this.getReservationCount('children'),
                            pets: this.getReservationCount('pets'),
                        },
                    ],
                ];
            },
            propertyChanged() {
                return (
                    this.airbnbReservationAlterationRequest.property_name !==
                    this.airbnbReservationAlterationRequest.property_name_original
                );
            },
            datesChanged() {
                return (
                    this.airbnbReservationAlterationRequestFromDateDisplay !==
                        this.airbnbReservationAlterationRequestFromDateOriginalDisplay ||
                    this.airbnbReservationAlterationRequestToDateDisplay !==
                        this.airbnbReservationAlterationRequestToDateOriginalDisplay
                );
            },
            guestsChanged() {
                return (
                    this.airbnbReservationAlterationRequestGuestsDisplay !==
                    this.airbnbReservationAlterationRequestGuestsOriginalDisplay
                );
            },
            hostPayoutChanged() {
                return (
                    this.airbnbReservationAlterationRequestPayoutOriginalDisplay &&
                    this.airbnbReservationAlterationRequestPayoutDisplay !==
                        this.airbnbReservationAlterationRequestPayoutOriginalDisplay
                );
            },
            airbnbReservationAlterationPending() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'PENDING'
                );
            },
            airbnbReservationAlterationAccepted() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'ACCEPTED'
                );
            },
            airbnbReservationAlterationDeclined() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'DECLINED'
                );
            },
            airbnbReservationAlterationCanceled() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'CANCELED'
                );
            },
            propertyChanged() {
                return (
                    this.airbnbReservationAlterationRequest.property_name !==
                    this.airbnbReservationAlterationRequest.property_name_original
                );
            },
            datesChanged() {
                return (
                    this.airbnbReservationAlterationRequestFromDateDisplay !==
                        this.airbnbReservationAlterationRequestFromDateOriginalDisplay ||
                    this.airbnbReservationAlterationRequestToDateDisplay !==
                        this.airbnbReservationAlterationRequestToDateOriginalDisplay
                );
            },
            guestsChanged() {
                return (
                    this.airbnbReservationAlterationRequestGuestsDisplay !==
                    this.airbnbReservationAlterationRequestGuestsOriginalDisplay
                );
            },
            hostPayoutChanged() {
                return (
                    this.airbnbReservationAlterationRequestPayoutOriginalDisplay &&
                    this.airbnbReservationAlterationRequestPayoutDisplay !==
                        this.airbnbReservationAlterationRequestPayoutOriginalDisplay
                );
            },
            airbnbReservationAlterationPending() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'PENDING'
                );
            },
            airbnbReservationAlterationAccepted() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'ACCEPTED'
                );
            },
            airbnbReservationAlterationDeclined() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'DECLINED'
                );
            },
            airbnbReservationAlterationCanceled() {
                return (
                    this.airbnbReservationAlterationRequest &&
                    this.airbnbReservationAlterationRequest.status === 'CANCELED'
                );
            },
            summaryTitle() {
                if (this.isAirbnb) {
                    if (this.airbnbReservationAlterationRequest) {
                        if (this.airbnbReservationAlterationAccepted) {
                            return 'Airbnb Reservation Alteration Request - Accepted';
                        }
                        if (this.airbnbReservationAlterationDeclined) {
                            return 'Airbnb Reservation Alteration Request - Declined';
                        }
                        if (this.airbnbReservationAlterationCanceled) {
                            return 'Airbnb Reservation Alteration Request - Canceled';
                        }
                        if (this.airbnbReservationAlterationRequest.initiated_for_guest) {
                            return "You've requested changes to this trip. Please wait for the guest to respond, or you can cancel the request.";
                        }
                        return 'The guest requested changes to their trip. You can accept the changes or keep the current Airbnb reservation.';
                    }
                    return 'Airbnb Reservation Summary';
                }
                if (this.values.is_quote) {
                    return 'Quote Summary';
                }
                return 'Reservation Summary';
            },
            stayTypeOptions() {
                return [
                    { value: 'GUEST', text: 'Guest Stay' },
                    { value: 'OWNER', text: 'Owner Stay' },
                ];
            },
            taxExemptionOptions() {
                return [
                    { value: false, text: 'No' },
                    { value: true, text: 'Yes' },
                ];
            },
            ignoreDoNotDegradeInvoiceStatusOptions() {
                return [
                    { value: false, text: 'No' },
                    { value: true, text: 'Yes' },
                ];
            },
            disallowSourceEditing() {
                if (!this.initialValues.is_quote) {
                    return true;
                }
                if (
                    this.initialValues.inquiry_source?.is_system &&
                    !this.initialValues.inquiry_source?.sysname === 'PHONE'
                ) {
                    return true;
                }
                return false;
            },
            isAirbnb() {
                return this.initialValues.booking_method === BOOKING_METHOD_AIRBNB;
            },
            airbnbReservationAlterationRequestFromDateDisplay() {
                return this.convertToUserTimezone(this.airbnbReservationAlterationRequest.from_date);
            },
            airbnbReservationAlterationRequestFromDateOriginalDisplay() {
                return this.convertToUserTimezone(this.airbnbReservationAlterationRequest.from_date_original);
            },
            airbnbReservationAlterationRequestToDateDisplay() {
                return this.convertToUserTimezone(this.airbnbReservationAlterationRequest.to_date);
            },
            airbnbReservationAlterationRequestToDateOriginalDisplay() {
                return this.convertToUserTimezone(this.airbnbReservationAlterationRequest.to_date_original);
            },
            airbnbReservationAlterationRequestGuestsDisplay() {
                return this.getGuestsDisplay({
                    adults: this.airbnbReservationAlterationRequest.adults,
                    children: this.airbnbReservationAlterationRequest.children,
                    pets: this.airbnbReservationAlterationRequest.pets,
                });
            },
            airbnbReservationAlterationRequestGuestsOriginalDisplay() {
                return this.getGuestsDisplay({
                    adults: this.airbnbReservationAlterationRequest.adults_original,
                    children: this.airbnbReservationAlterationRequest.children_original,
                    pets: this.airbnbReservationAlterationRequest.pets_original,
                });
            },
            airbnbReservationAlterationRequestTotalDisplay() {
                return toAmountDisplay({
                    amount: this.airbnbReservationAlterationRequest.total,
                    currency: this.userCurrencySymbol,
                });
            },
            airbnbReservationAlterationRequestPayoutDisplay() {
                return toAmountDisplay({
                    amount: this.airbnbReservationAlterationRequest.payout,
                    currency: this.userCurrencySymbol,
                });
            },
            airbnbReservationAlterationRequestPayoutOriginalDisplay() {
                if (this.airbnbReservationAlterationRequest.payout_original) {
                    return toAmountDisplay({
                        amount: this.airbnbReservationAlterationRequest.payout_original,
                        currency: this.userCurrencySymbol,
                    });
                }
            },
            airbnbReservationAlterationPriceQuotePayoutDisplay() {
                return toAmountDisplay({
                    amount: this.airbnbReservationAlterationPriceQuote.payout,
                    currency: this.userCurrencySymbol,
                });
            },
            airbnbReservationAlterationPriceQuotePayoutOriginalDisplay() {
                if (this.airbnbReservationAlterationPriceQuote.payout_original) {
                    return toAmountDisplay({
                        amount: this.airbnbReservationAlterationPriceQuote.payout_original,
                        currency: this.userCurrencySymbol,
                    });
                }
            },
            airbnbReservationAlterationPriceQuoteTotalDisplay() {
                return toAmountDisplay({
                    amount: this.airbnbReservationAlterationPriceQuote.total,
                    currency: this.userCurrencySymbol,
                });
            },
            nights() {
                return differenceInDays(parseISO(this.values.to_date), parseISO(this.values.from_date));
            },
            nightsDisplay() {
                return this.nights === 1 ? '1 night' : `${this.nights} nights`;
            },
            pricePerNightDisplay() {
                return toAmountDisplay({
                    amount: !!this.nights ? (this.values.total_price || 0) / this.nights : 0,
                    currency: this.userCurrencySymbol,
                });
            },
            airbnbReservationAlterationRequestLodgixStatusMessage() {
                if (
                    [ALTERATION_REQUEST_SENT_FOR_ACCEPTANCE, ALTERATION_REQUEST_SENT_FOR_DECLINE].includes(
                        this.values.airbnb_data_lodgix_status
                    )
                ) {
                    return [
                        `The request to ${
                            this.values.airbnb_data_lodgix_status === ALTERATION_REQUEST_SENT_FOR_ACCEPTANCE
                                ? 'accept'
                                : 'decline'
                        } the alteration request was successfully sent to
                  Airbnb.`,
                        'The data of this reservation will be updated once Lodgix receives confirmation from Airbnb.',
                        'This usually takes less than a minute to confirm.',
                    ];
                }
                return '';
            },
        },
        data() {
            return {
                loading: false,
                values: this.getInitialValues(),
                inquirySourceData: { options: [] },
                ignoreRulesModalValues: {},
                conflictsModalValues: {},
                nColsTaxExemptionMD: 6,
                nColsTaxExemptionLG: 6,
                nColsReservationTypeMD: 6,
                nColsReservationTypeLG: 3,
                canModifyInvoiceCreatedDate: false,
                canManageInquiries: false,
                isQuoteModeSend: false,
                incorrectAlterationIdMessage: '',
                inquirySourceSetupModalId: 'inquiry-setup-source-modal',
                airbnbPropertyOptions: [],
                airbnbReservationAlterationLoading: false,
                airbnbReservationAlterationRequest: undefined,
                airbnbReservationAlterationPriceQuote: undefined,
                airbnbReservationAlterationRequestAcceptModalId: `airbnb-reservation-alteration-request-accept-${(
                    Math.random() + 1
                )
                    .toString(36)
                    .substring(7)}`,
                airbnbReservationAlterationRequestDeclineModalId: `airbnb-reservation-alteration-request-decline-${(
                    Math.random() + 1
                )
                    .toString(36)
                    .substring(7)}`,
                airbnbReservationAlterationRequestCancelModalId: `airbnb-reservation-alteration-request-cancel-${(
                    Math.random() + 1
                )
                    .toString(36)
                    .substring(7)}`,
                airbnbReservationAlterationRequestSendModalId: `airbnb-reservation-alteration-request-send-${(
                    Math.random() + 1
                )
                    .toString(36)
                    .substring(7)}`,
                fields: [
                    [
                        {
                            key: 'start_date',
                            label: 'Start Date',
                        },
                        {
                            key: 'end_date',
                            label: 'End Date',
                        },
                        {
                            key: 'length',
                            label: 'Length',
                        },
                    ],
                    [
                        {
                            key: 'adults',
                            label: 'Adults',
                        },
                        {
                            key: 'children',
                            label: 'Children',
                        },
                        {
                            key: 'pets',
                            label: 'Pets',
                        },
                    ],
                ],
            };
        },
        methods: {
            getInitialValues() {
                return {
                    id: this.initialValues.id || null,
                    user_id: this.initialValues.user_id || null,
                    email: this.initialValues.email || '',
                    booking_method: this.initialValues.booking_method || '',
                    first_name: this.initialValues.first_name || '',
                    last_name: this.initialValues.last_name || '',
                    full_name: this.initialValues.full_name || '',
                    from_date: this.initialValues.from_date || '',
                    to_date: this.initialValues.to_date || '',
                    auto_generate: this.initialValues.auto_generate || false,
                    is_quote: this.initialValues.is_quote || false,
                    properties: this.initialValues.properties || [],
                    adults: this.initialValues.adults || 1,
                    children: this.initialValues.children || 0,
                    pets: this.initialValues.pets || 0,
                    ignore_rules: false,
                    entered_date: null,
                    total_price: null,
                    airbnb_feedshare_id: this.initialValues?.properties?.[0]?.airbnb_feedshare_id || '',
                    stay_type: this.initialValues.stay_type || 'GUEST',
                    tax_exemption: this.initialValues.tax_exemption || false,
                    tax_exemption_code: this.initialValues.tax_exemption_code || null,
                    ignore_do_not_degrade: false,
                    inquiry_source: this.initialValues.inquiry_source || null,
                    inquiry_source_id: this.initialValues.inquiry_source?.id || null,
                    discount_pk: this.initialValues.discount_pk || null,
                    inquiry_pk: this.initialValues.inquiry_pk || null,
                    airbnb_data_lodgix_status: this.initialValues?.airbnb_data_lodgix_status || '',
                };
            },
            refresh() {
                this.fetchAirbnbReservationAlterationRequest();
            },
            convertToUserTimezone(value) {
                return value && format(parseISO(value), this.userUnicodeDateFormat);
            },
            handleCancelClick() {
                this.$bvModal.show(this.airbnbReservationAlterationRequestCancelModalId);
            },
            handleSendRequestClick() {
                this.$bvModal.show(this.airbnbReservationAlterationRequestSendModalId);
            },
            handleAcceptClick() {
                this.$bvModal.show(this.airbnbReservationAlterationRequestAcceptModalId);
            },
            handleDeclineClick() {
                this.$bvModal.show(this.airbnbReservationAlterationRequestDeclineModalId);
            },
            getGuestsDisplay({ adults, children, pets }) {
                const guests = [];
                if (adults) {
                    const label = adults === 1 ? 'adult' : 'adults';
                    guests.push(`${adults} ${label}`);
                }
                if (children) {
                    const label = children === 1 ? 'child' : 'children';
                    guests.push(`${children} ${label}`);
                }
                if (pets) {
                    const label = pets === 1 ? 'pet' : 'pets';
                    guests.push(`${pets} ${label}`);
                }
                return guests.join(', ');
            },
            async update() {
                try {
                    let values = this.values;
                    values.inquiry_source = values.inquiry_source_id;
                    let response = await this.$store.dispatch('reservation/updateReservationDetails', values);
                    this.values.ignore_rules = false;
                    this.successToast({ text: 'Reservation successfully updated.' });
                } catch (err) {
                    if (err.response.status === 400) {
                        if (err.response.data.error_code && err.response.data.error_code == 'INVALID_RULES') {
                            this.ignoreRulesModalValues = err.response.data;
                            this.$bvModal.show('ignoreRulesModal');
                        } else if (err.response.data.error_code && err.response.data.error_code == 'CONFLICT') {
                            this.conflictsModalValues = err.response.data;
                            this.$bvModal.show('conflictsModal');
                        } else {
                            this.errorToast({ text: err.response.data.message });
                        }
                    } else {
                        this.errorToast({ text: 'Could not update reservation.' });
                    }
                }
            },
            async create() {
                try {
                    let values = this.values;
                    values.inquiry_source = values.inquiry_source_id;
                    const reservation = await this.$store.dispatch('reservation/createReservationDetails', values);
                    this.values.ignore_rules = false;
                    if (this.values.is_quote && this.isQuoteModeSend) {
                        window.location = `/app/reservation/invoice/${reservation.id}/control-panel/send`;
                    } else {
                        window.location = `/app/reservation/edit/invoice/${reservation.id}`;
                    }
                } catch (err) {
                    if (err.response.status === 400) {
                        if (err.response.data.error_code && err.response.data.error_code == 'INVALID_RULES') {
                            this.ignoreRulesModalValues = err.response.data;
                            this.$bvModal.show('ignoreRulesModal');
                        } else if (err.response.data.error_code && err.response.data.error_code == 'CONFLICT') {
                            this.conflictsModalValues = err.response.data;
                            this.$bvModal.show('conflictsModal');
                        } else {
                            this.errorToast({ text: err.response.data.message });
                        }
                    } else {
                        this.errorToast({ text: 'Could not save reservation.' });
                    }
                }
            },
            async send() {
                this.isQuoteModeSend = true;
                this.processSave();
            },
            async save() {
                this.isQuoteModeSend = false;
                this.processSave();
            },
            async saveIgnore() {
                this.processSave(true);
            },
            async processSave(ignoreRules) {
                this.loading = true;

                this.values.ignore_rules = ignoreRules || false;

                try {
                    await (this.initialValues.id ? this.update() : this.create());
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
            formatDateWithWeekday(date) {
                if (date) {
                    return format(parseISO(date), 'EEE, MMM dd, yyyy');
                }
            },
            getReservationCount(field) {
                let count = 0;
                for (let i = 0; i < this.values.properties.length; i++) {
                    count += this.values.properties[i][field] || 0;
                }
                return count;
            },
            getReservationLength() {
                return differenceInDays(parseISO(this.values.to_date), parseISO(this.values.from_date));
            },
            handleFromDateChange(value) {
                const from_date = parseISO(value);
                const to_date = parseISO(this.values.to_date || new Date());
                if (to_date <= from_date || !dateFnsIsValid(to_date)) {
                    this.values.to_date = format(addDays(from_date, 1), 'yyyy-MM-dd');
                }
                this.fetchAirbnbReservationAlterationQuoteDebounce();
                this.$nextTick(() => {
                    this.$refs.toDatePicker.show();
                });
            },
            handleToDateChange(value) {
                const from_date = parseISO(this.values.from_date);
                const to_date = parseISO(this.values.to_date);
                if (from_date >= to_date || !dateFnsIsValid(from_date)) {
                    this.values.from_date = format(subDays(to_date, 1), 'yyyy-MM-dd');
                }
                this.fetchAirbnbReservationAlterationQuoteDebounce();
            },
            setReservationGuest(values) {
                this.values.user_id = values.id;
                this.values.email = values.email;
                this.values.auto_generate = values.autoGenerate;
                this.values.first_name = values.first_name;
                this.values.last_name = values.last_name;
                this.values.full_name = values.first_name + ' ' + values.last_name;
            },
            async fetchAirbnbReservationAlterationRequest() {
                if (this.isAirbnb) {
                    try {
                        this.airbnbReservationAlterationLoading = true;
                        const response = await API.get(
                            GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_FETCH_ENDPOINT(
                                this.values.id,
                                this.values.user_id,
                                this.alterationId
                            )
                        );
                        this.airbnbReservationAlterationRequest = response.data || null;
                    } catch (e) {
                        const { generic } = formatResponseError(e);
                        if (generic === 'Invalid alteration id.') {
                            this.incorrectAlterationIdMessage = 'Incorrect alteration id';
                        } else {
                            this.errorToast({
                                text: generic || 'Could not load Airbnb reservation alteration request.',
                            });
                        }
                    } finally {
                        this.airbnbReservationAlterationLoading = false;
                    }
                }
            },
            async fetchAirbnbProperties() {
                if (this.isAirbnb) {
                    try {
                        this.loading = true;
                        const { data } = await API.get(PARTNER_AIRBNB_FEED_SHARE_AIRBNB_PROPERTIES_ENDPOINT());
                        this.airbnbPropertyOptions = data.map((item) => ({
                            value: item.id,
                            text: item.rental_property.name,
                        }));
                    } catch (error) {
                        const { generic } = formatResponseError(error);
                        this.errorToast({ text: generic || 'Could not fetch airbnb property options.' });
                    } finally {
                        this.loading = false;
                    }
                }
            },
            async fetchAirbnbReservationAlterationQuote() {
                if (this.isAirbnb) {
                    this.loading = true;
                    try {
                        const { data } = await API.post(
                            GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_QUOTE_ENDPOINT(this.values.id, this.values.user_id),
                            this.values
                        );
                        this.airbnbReservationAlterationPriceQuote = data;
                    } catch (e) {
                        const { generic } = formatResponseError(e);
                        this.errorToast({ text: generic || 'Could not fetch price quote.' });
                    } finally {
                        this.loading = false;
                    }
                }
            },
            fetchAirbnbReservationAlterationQuoteDebounce: debounce(function () {
                this.fetchAirbnbReservationAlterationQuote();
            }, 500),
            async accept() {
                this.loading = true;
                try {
                    await API.post(
                        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_ACCEPT_ENDPOINT(
                            this.airbnbReservationAlterationRequest.lodgix_id,
                            this.values.id,
                            this.values.user_id
                        )
                    );
                    this.successToast({
                        text:
                            'The request was successfully sent to Airbnb. The data of ' +
                            'this reservation will be updated once Lodgix receives confirmation from Airbnb.',
                    });
                    this.fetchReservationDetails();
                    this.refresh();
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not accept Airbnb reservation alteration request.' });
                } finally {
                    this.loading = false;
                }
            },
            async decline() {
                this.loading = true;
                try {
                    await API.post(
                        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_DECLINE_ENDPOINT(
                            this.airbnbReservationAlterationRequest.lodgix_id,
                            this.values.id,
                            this.values.user_id
                        )
                    );
                    this.successToast({
                        text: 'Airbnb reservation alteration request was declined successfully.',
                    });
                    this.fetchReservationDetails();
                    this.refresh();
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not decline Airbnb reservation alteration request.' });
                } finally {
                    this.loading = false;
                }
            },
            async cancelRequest() {
                this.loading = true;
                try {
                    await API.post(
                        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_CANCEL_ENDPOINT(
                            this.airbnbReservationAlterationRequest.lodgix_id,
                            this.values.id,
                            this.values.user_id
                        )
                    );
                    this.successToast({
                        text: 'Airbnb reservation alteration request was canceled successfully.',
                    });
                    this.refresh();
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not cancel Airbnb reservation alteration request.' });
                } finally {
                    this.loading = false;
                }
            },
            async sendRequest() {
                this.loading = true;
                try {
                    await API.post(
                        GUEST_AIRBNB_RESERVATION_ALTERATION_REQUEST_SEND_ENDPOINT(this.values.id, this.values.user_id),
                        this.values
                    );
                    this.successToast({
                        text: 'Airbnb reservation alteration request was sent successfully.',
                    });
                    this.refresh();
                } catch (e) {
                    const { generic } = formatResponseError(e);
                    this.errorToast({ text: generic || 'Could not send Airbnb reservation alteration request.' });
                } finally {
                    this.loading = false;
                }
            },
            async fetchReservationDetails() {
                try {
                    await this.$store.dispatch('reservation/fetchReservationDetails', { id: this.values.id });
                } catch (err) {
                    this.errorToast({ text: 'Could not load reservation data.' });
                }
            },
            async fetchInquirySourceData() {
                if (this.initialValues.is_quote) {
                    if (!this.disallowSourceEditing) {
                        const response = await API.get(RESERVATION_DETAILS_INQUIRY_SOURCE_DATA_ENDPOINT());
                        this.inquirySourceData = response.data;
                        if (this.isCreate) {
                            if (this.inquirySourceData.force_manual_source_choice) {
                                this.inquirySourceData.options.unshift({
                                    value: null,
                                    text: 'Please select a source',
                                });
                                this.values.inquiry_source_id = null;
                            } else if (!isNil(this.inquirySourceData.default_manual_inquiry_source)) {
                                this.values.inquiry_source_id = this.inquirySourceData.default_manual_inquiry_source;
                            }
                        }
                    } else {
                        this.inquirySourceData = { options: [this.initialValues.inquiry_source] };
                    }
                }
            },    
            getAvailablePropertiesRequestData() {
                return {
                    id: this.values.id,
                    from_date: this.values.from_date,
                    to_date: this.values.to_date,
                    exclude: this.values.properties,
                };
            },
            onResize() {},
            getSaveButtonText() {
                const action = this.initialValues.id ? 'Update' : 'Create';
                const target = this.values.is_quote ? 'Quote' : 'Reservation';                
                return `${action} ${target} `;
            },
            async handleRefreshInquirySources() {
                this.loading = true;
                try {
                    await this.fetchInquirySourceData();
                } catch (e) {
                    console.log(e);
                } finally {
                    this.loading = false;
                }                    
            }
        },
        watch: {
            initialValues() {
                this.values = this.getInitialValues();
                this.$refs.form.setValues({
                    ...this.getInitialValues(),
                });
            },
            userToday(value) {
                if (isNil(this.values.entered_date)) {
                    this.values.entered_date = value;
                }
            },
            values: {
                deep: true,
                handler(values) {
                    if (this.isCreate) {
                        if (this.values.tax_exemption) {
                            this.nColsTaxExemptionMD = 6;
                            this.nColsTaxExemptionLG = 3;
                        } else {
                            this.nColsTaxExemptionMD = 12;
                            this.nColsTaxExemptionLG = 6;
                        }
                    } else {
                        if (this.values.tax_exemption) {
                            this.nColsTaxExemptionMD = 4;
                            this.nColsTaxExemptionLG = 3;
                        } else {
                            this.nColsTaxExemptionMD = 8;
                            this.nColsTaxExemptionLG = 6;
                        }
                    }
                    this.$refs.form.setValues(values);
                },
            },
            userPermissions(value) {
                this.canModifyInvoiceCreatedDate = this.userPermissions.can_modify_invoice_created_date;
                this.canManageInquiries = this.userPermissions.can_manage_inquiries;
                if (this.canModifyInvoiceCreatedDate) {
                    this.nColsReservationTypeMD = 6;
                    this.nColsReservationTypeLG = 3;
                } else {
                    this.nColsReservationTypeMD = 12;
                    this.nColsReservationTypeLG = 6;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    :deep(.summary-card) {
        .card-title {
            font-size: 18px !important;
            color: #fff;
        }
    }

    :deep(.summary-table) {
        border-collapse: separate !important;
        border-spacing: 10px 0;
        color: #fff !important;
        width: 50% !important;
        float: left;

        :deep(.summary-header) {
            text-transform: uppercase;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
        }

        :deep(.summary-body) {
            color: #fff;
            font-size: 28px;
            font-weight: bold;
        }
    }

    :deep(.summary-table-1) {
        margin-right: -10px;
    }

    :deep(.summary-table-thead-tr th) {
        text-transform: uppercase;
        border: 0 !important;
        background-color: rgba(255, 255, 255, 0.1);
        padding: 10px;
        white-space: no-wrap;
        color: #6f94cc;
    }

    :deep(.summary-table-tbody-tr td) {
        font-size: 22px;
        border: 0 !important;
        background-color: rgba(255, 255, 255, 0.1);
        padding: 50px;
        max-width: 165px;
        width: 165px;
        min-height: 100px;
        white-space: no-wrap;
    }

    .link-disabled,
    .link-disabled:hover {
        color: gray;
        text-decoration: none;
    }

    :deep(#guest-input) {
        cursor: pointer;
    }

    :deep(.guest-container) {
        span {
            font-size: 50px;
            :deep(fieldset) {
                margin-bottom: 0 !important;
            }
        }
    }

    .properties-container .row.div {
        text-align: left !important;
    }

    :deep(.b-table-stacked-md > tbody > tr > [data-label]::before) {
        float: none !important;
    }

    :deep(.bg-transparent) {
        background-color: '#F1F1F1' !important;
    }

    :deep(.ldx-form-select) {
        background: #f1f1f1
            url("data:image/svg+xml,%3Csvg width='40' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='44' height='44' fill='%230D47A1'/%3E%3Cpath d='M16 19L22 25L28 19' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A")
            no-repeat right !important;
        cursor: pointer;
    }

    :deep(label) {
        font-weight: bold !important;
    }

    .save-button {
        font-weight: bold !important;
        align-items: center;
        justify-content: center;
        display: inline-flex !important;
        margin-top: 5px;
        minimum-width: 120px;
    }

    .divider {
        text-align: center;
        width: 100%;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    :deep(.invalid-feedback) {
        font-size: 12px !important;
    }

    :deep(.ldx-form-input) {
        background: #f1f1f1 !important;
    }

    :deep(.datepicker-floating-label) {
        button.h-auto {
            order: 2;
            color: #fff !important;
            background-color: #0d47a1;
            border-color: #0d47a1;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }

        button.h-auto:hover {
            color: #fff !important;
            background-color: #0c4295;
            border-color: #0c4091;
        }

        .form-control {
            background: #f1f1f1 !important;
            font-weight: normal !important;
            padding-left: 10px !important;
        }

        .dropdown-menu {
            transform: none !important;
            top: 40px !important;
        }

        .b-calendar-grid {
            background-color: #fff !important;
        }
    }
    
    :deep(.inquiry-source-setup-button) {
        padding: 0.375rem 0.75rem !important;
    }

    @include media-breakpoint-down(xl) {
        :deep(.summary-table-thead-tr th) {
            font-size: 16px;
            font-weight: bold;
            color: #6f94cc;
        }

        :deep(.summary-table-tbody-tr td) {
            font-size: 18px;
            font-weight: bold;
        }
    }

    @include media-breakpoint-down(lg) {
        :deep(.summary-table) {
            width: 100% !important;
        }
    }

    @include media-breakpoint-down(md) {
        :deep(.tax-exemption-switch.v-switch-core) {
            height: 80px !important;
        }

        :deep(div.ag-theme-alpine div.ag-row),
        :deep(div.ag-theme-alpine div.ag-header-row) {
            font-size: 15px !important;
        }

        :deep(.summary-table-thead-tr th) {
            font-size: 14px;
            font-weight: bold;
            color: #6f94cc;
        }

        :deep(.summary-table-tbody-tr td) {
            font-size: 16px;
            font-weight: bold;
        }

        .save-button {
            width: 100%;
        }
    }

    @include media-breakpoint-down(sm) {
        :deep(.summary-container) {
            display: none !important;
        }

        :deep(.summary-table-thead-tr th) {
            font-size: 12px;
            font-weight: bold;
            color: #6f94cc;
        }

        :deep(.summary-table-tbody-tr td) {
            font-size: 14px;
            font-weight: bold;
            width: 100px;
            padding-top: 3px !important;
            min-height: 150px;
        }
    }

    @include media-breakpoint-down(xs) {
        :deep(.summary-container) {
            display: none !important;
        }

        :deep(.summary-table-thead-tr th) {
            font-size: 8px;
            font-weight: bold;
            color: #6f94cc;
        }

        :deep(.summary-table-tbody-tr td) {
            font-size: 8px;
            font-weight: bold;
            width: 80px;
            min-width: 80px;
            padding-top: 3px !important;
            min-height: 150px;
        }
    }
</style>
